module.exports = __webpack_public_path__ + "static/media/pdf.4090d928.png";